import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import ThemeContext from '../../../providers/ThemeProvider';

const VipMessageWrapper = ({ children, isRadioHeading = false }) => {
  const theme = useContext(ThemeContext);

  return (
    <>
      <div className="message-container">
        <div className="message">{children}</div>
      </div>
      <style jsx>{`
        .message-container {
          width: 100%;
        }
        .message {
          background-color: ${theme.commoncolors.greyx2lighter};
          color: ${theme.commoncolors.black};
          flex-basis: calc(20% - 15px);
          font-size: 18px;
          font-weight: bold;
          margin-bottom: ${isRadioHeading ? '0' : '10px'};
          padding: 10px 15px;
          text-align: ${isRadioHeading ? 'left' : 'center'};
          text-transform: ${isRadioHeading ? theme.text.transform : ''};
          width: 100%;
        }
        :global(.message .primary) {
          color: ${theme.colors.primary};
          font-weight: bold;
        }
      `}</style>
    </>
  );
};

VipMessageWrapper.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  isRadioHeading: PropTypes.bool,
};

export default VipMessageWrapper;
